export default {"src":"/_next/static/image/public/images/ic_aster_secure_vertical_menu.012becb0c2afab4a66a62df7ab01d0d4.svg","height":20,"width":20};